import { render, staticRenderFns } from "./HeaderBasketNew.vue?vue&type=template&id=730f0a9e"
import script from "./HeaderBasketNew.vue?vue&type=script&lang=js"
export * from "./HeaderBasketNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports